import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = "Mon Premier Jeu",
  description = "Apprends à coder tes jeux vidéo en PUR CODE sans moteur, sans installation, directement depuis ce site. Formation accessible aux débutants dès 10 ans, aucun prérequis nécessaire !",
  keywords = "programmation, jeux vidéo, p5.js, tutorial, tuto, tutoriel, JavaScript, formation, cours, débutant, enfant, code, développement",
  image = "/icon.png",
  url = "",
  type = "website",
  siteName = "Mon Premier Jeu",
  author = "Mon Premier Jeu"
}) => {
  const siteUrl = window.location.origin;
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  const fullImageUrl = image.startsWith('http') ? image : `${siteUrl}${image}`;

  return (
    <Helmet>
      {/* Méta-données de base */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={fullUrl} />
      
      {/* Open Graph (Facebook, LinkedIn) */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="fr_FR" />
      
      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImageUrl} />
      <meta name="twitter:url" content={fullUrl} />
      
      {/* Méta-données spécifiques à l'éducation */}
      <meta name="subject" content="Programmation et développement de jeux vidéo" />
      <meta name="audience" content="Débutants, enfants, adolescents, adultes" />
      <meta name="educational-use" content="Apprentissage de la programmation" />
      <meta name="intended-end-user" content="Étudiants, enseignants, parents" />
      
      {/* Géolocalisation */}
      <meta name="geo.region" content="FR" />
      <meta name="geo.placename" content="France" />
      <meta name="language" content="French" />
      
      {/* Méta-données pour les moteurs de recherche */}
      <meta name="rating" content="General" />
      <meta name="revisit-after" content="7 days" />
      <meta name="distribution" content="Global" />
      
      {/* JSON-LD Schema.org */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "EducationalOrganization",
          "name": "Mon Premier Jeu",
          "description": description,
          "url": fullUrl,
          "logo": fullImageUrl,
          "sameAs": [],
          "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "customer service",
            "availableLanguage": "French"
          },
          "offers": {
            "@type": "Offer",
            "name": "Pass Codeur",
            "description": "Accès complet à tous les cours de programmation de jeux vidéo",
            "price": "4.99",
            "priceCurrency": "EUR"
          },
          "educationalCredentialAwarded": "Certificat de programmation de jeux vidéo",
          "teaches": [
            "Programmation JavaScript",
            "Développement de jeux vidéo",
            "P5.js",
            "Logique de programmation"
          ]
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
